import React, { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

// Create a new context
export const AppContext = React.createContext();

// Create a provider component
export function AppContextProvider({ children }) {
  const { getAccessTokenSilently } = useAuth0();
  const [appState, setAppState] = useState({
    caseId: null,
    generatedNote: null,
    generatedNoteText: null,
    // Add more state variables here as needed
  });
  const [accessToken, setAccessToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAccessToken = async () => {
      setLoading(true);
      try {
        const token = await getAccessTokenSilently({
          authorizationParams: {
            audience: `${process.env.REACT_APP_AUTH0_AUDIENCE}`,
            scope: "read:current_user",
          },
          detailedResponse: true,
        });
        setAccessToken(token.access_token);
        setError(null);
      } catch (error) {
        console.error('Error getting access token', error);
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchAccessToken();
  }, [getAccessTokenSilently]);

  // The value that will be provided to consuming components
  const value = { appState, setAppState, accessToken, loading, error };

  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>
  );
}